import { Modal } from "./Modal";
import { SavePaymentForm } from "../Form/Forms/Payment/SavePaymentForm";

export function SavePaymentModal({ open, setOpen }) {
  return (
    <Modal open={open} setOpen={setOpen}>
      <SavePaymentForm open={open} setOpen={setOpen} />
    </Modal>
  );
}
